import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface User {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    role: string;
    tenantId: string;
    defaultRoute?: string;
}

interface AuthState {
    token: string | null;
    user: User | null;
    tenantId: string | null;
    setAuth: (token: string, user: User) => void;
    logout: () => void;
    setTenant: (tenantId: string) => void;
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set: (partial: Partial<AuthState>) => void) => ({
            token: null,
            user: null,
            tenantId: null,
            setAuth: (token: string, user: User) => set({ token, user, tenantId: user.tenantId }),
            logout: () => set({ token: null, user: null, tenantId: null }),
            setTenant: (tenantId: string) => set({ tenantId }),
        }),
        {
            name: 'vsys-auth-storage', // saves to localStorage securely
        }
    )
);
